import { render, staticRenderFns } from "./observed_1.vue?vue&type=template&id=962c9776&scoped=true&"
var script = {}
import style0 from "./observed_1.vue?vue&type=style&index=0&id=962c9776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962c9776",
  null
  
)

export default component.exports